// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.noData[data-v-cae69ee0] {\n  text-align: center;\n  margin: 40px auto;\n}\n.noData img[data-v-cae69ee0] {\n  width: 53px;\n  height: auto;\n  margin-top: 40px;\n}\n.noData p[data-v-cae69ee0] {\n  text-align: center;\n  font-weight: bold;\n  color: dimgray;\n\n  line-height: 8px;\n  color: #b1bcc3;\n  font-size: 12px;\n  margin-top: 7px;\n  padding-bottom: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
